module.exports = __webpack_public_path__ + "static/img/available-box.a545be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/inventory/available-box.png
// module id = +kCO
// module chunks = 134